<template>
  <b-card-code title="">
    <div class="row mb-2">
      <div class="col-lg-6">
        <h4>Projektek</h4>
      </div>
      <div class="col-lg-6 d-flex flex-column flex-md-row justify-content-md-end align-items-stretch align-items-md-center">
        <div
          class="btn-group project-view-toggle mb-1 mb-md-0 mr-md-2"
          role="tablist"
          aria-label="Projekt nézetváltó"
        >
          <button
            type="button"
            class="btn"
            :class="currentProjectView === 'active' ? 'btn-primary active' : 'btn-outline-primary'"
            :aria-selected="currentProjectView === 'active'"
            role="tab"
            @click="goToProjectView('active')"
          >
            Összes projekt
          </button>
          <button
            type="button"
            class="btn"
            :class="currentProjectView === 'archived' ? 'btn-primary active' : 'btn-outline-primary'"
            :aria-selected="currentProjectView === 'archived'"
            role="tab"
            @click="goToProjectView('archived')"
          >
            Archivált projektek
          </button>
        </div>
        <button
          class="btn btn-success"
          @click="$router.push('/projects/create/full')"
        >
          Projekt létrehozás
        </button>
      </div>
    </div>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Name -->
        <div
          v-if="props.column.field === 'name'"
          class="text-nowrap"
        >
          <span class="text-nowrap">{{ props.row.name }}</span>
        </div>

        <div v-else-if="props.column.field === 'price'">
          <span>{{ $formatFt(props.row.price) }}</span>
        </div>

        <div v-else-if="props.column.field === 'archive'">
          <span v-if="props.row.archive">Archivált</span>
          <span v-else>Aktív</span>
        </div>

        <!-- Column: Status -->
        <!--<span v-else-if="props.column.field === 'status'">
          <b-badge :variant="statusVariant(props.row.status)">
            {{ props.row.status }}
          </b-badge>
        </span>-->

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <!--<b-dropdown-item v-b-modal.changeStatusModal @click="changeStatus(props.row.id)">
                <feather-icon
                  icon="CheckCircleIcon"
                  class="mr-50"
                />
                <span>Státusz állítás</span>
              </b-dropdown-item>-->
              <!--<b-dropdown-item @click="show(props.row.id)">
                <feather-icon
                  icon="EyeIcon"
                  class="mr-50"
                />
                <span>Feladatok</span>
              </b-dropdown-item>-->
              <!--<b-dropdown-item @click="document(props.row.id)">
                <feather-icon
                  icon="FileTextIcon"
                  class="mr-50"
                />
                <span>Dokumentum generálás</span>
              </b-dropdown-item>-->
              <b-dropdown-item
                v-show="checkRole()"
                @click="$router.push('/project/list/documents/'+props.row.id)"
              >
                <feather-icon
                  icon="FileTextIcon"
                  class="mr-50"
                />
                <span>Dokumentumok</span>
              </b-dropdown-item>
              <b-dropdown-item @click="$router.push('/project/list/invoice/'+props.row.id)">
                <feather-icon
                  icon="FileIcon"
                  class="mr-50"
                />
                <span>Számlák</span>
              </b-dropdown-item>
              <b-dropdown-item @click="arachive(props.row.id)">
                <feather-icon
                  icon="FolderIcon"
                  class="mr-50"
                />
                <span>Státusz állítása</span>
              </b-dropdown-item>
              <b-dropdown-item @click="editProject(props.row.id)">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Szerkesztés</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Mutasd 1-től
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['25','50','100']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap ">-ig a {{ props.total }} elemet </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BPagination, BFormSelect, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import axios from 'axios'

export default {
  components: {
    BCardCode,
    VueGoodTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      pageLength: 25,
      dir: false,
      columns: [
        {
          label: 'Munkaszám',
          field: 'work_number',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés munkaszám',
          },
        },
        {
          label: 'Projekt neve',
          field: 'name',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés névre',
          },
        },
        {
          label: 'Megrendelő',
          field: 'customer',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés megrendelők között',
          },
        },
        {
          label: 'Kezdés dátuma',
          field: 'start_date',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés kezdésre',
          },
        },
        {
          label: 'Határidő',
          field: 'end_date',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés határidőre',
          },
        },
        {
          label: 'Vállalt összeg',
          field: 'price',
          tdClass: 'text-right',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés összegre',
          },
        },
        {
          label: 'Építés vezető',
          field: 'foreman_name',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés Építés vezetőre',
          },
        },
        {
          label: 'Előkészítő',
          field: 'preparatory_name',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés Építés vezetőre',
          },
        },
        {
          label: 'Státusz',
          field: 'archive',
          filterOptions: {
            enabled: false,
            placeholder: 'Keresés Építés vezetőre',
          },
        },
        {
          label: '',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  computed: {
    currentProjectView() {
      return this.$route.path === '/project/list/archive' ? 'archived' : 'active'
    },
    statusVariant() {
      const statusColor = {
        Folyamatban: 'light-info',
        Késésben: 'light-warning',
        Lejárt: 'light-danger',
        Kész: 'light-success',
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    this.getProjects()
  },
  methods: {
    goToProjectView(view) {
      const targetRoute = view === 'archived' ? '/project/list/archive' : '/project/list'

      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute)
      }
    },
    checkRole() {
      return JSON.parse(localStorage.getItem('user')).role.includes('documents_list')
    },
    arachive(id) {
      axios({
        method: 'put',
        url: `project/archive-inverse/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.getProjects()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeresen státusz állítva',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'A projekthez tartozó bank garancia hiányzik!',
            icon: 'XOctagonIcon',
            variant: 'danger',
          },
        })
      })
    },
    editProject(id) {
      this.$router.push({ name: 'monolit.projects.edit', params: { id } })
    },
    getProjects() {
      axios({
        method: 'get',

        url: 'project/list-all',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.rows = response.data
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
